export interface StandardizedMapping {
  targetEmoji: string;
  emojiCode: string;
  category?: string;
  description?: string;
}

export interface ReverseMappingEntry {
  sourceChar: string;
  emojiCode: string;
}

export interface CipherMappingMetadata {
  lastModified: string;
  categories?: string[];
  description?: string;
}

export interface CipherMapping {
  forward: Record<string, StandardizedMapping>;
  reverse: Record<string, ReverseMappingEntry>;
  cipher_code: string;
  version: string;
  metadata?: CipherMappingMetadata;
}

export interface CharacterSetEntry {
  id: string;
  setId: string;
  character: string;
  position: number;
}

export interface EmojiSetEntry {
  id: string;
  setId: string;
  emoji: string;
  emojiCode: string;
  position: number;
}

export const CIPHER_SECURITY_LEVELS = ["basic", "standard", "advanced"] as const;
export type CipherSecurityLevel = (typeof CIPHER_SECURITY_LEVELS)[number];

export const CIPHER_STATUSES = ["draft", "active", "archived"] as const;
export type CipherStatus = (typeof CIPHER_STATUSES)[number];

export const CIPHER_OPERATIONS = ["encrypt", "decrypt"] as const;
export type CipherOperation = (typeof CIPHER_OPERATIONS)[number];

export const USER_CIPHER_ACCESS_TYPES = [
  "saved",
  "requested",
  "approved",
  "rejected",
] as const;
export type UserCipherAccessType = (typeof USER_CIPHER_ACCESS_TYPES)[number];

export const VERIFICATION_REQUEST_STATUSES = [
  "pending",
  "approved",
  "rejected",
  "expired",
] as const;
export type VerificationRequestStatus =
  (typeof VERIFICATION_REQUEST_STATUSES)[number];
